<template>
  <div class="container">
    <p>
      为了方便整理全文的要点、方法、实现过程，对全文进行整体的总结，减轻读者阅读压力，提高阅读速度，帮助读者快速上手文章，提供系统AI全文解析工具，读者可在文章页面点击全文解析或者文献服务平台选取相关文献，系统自动解析文章内容。总结要点方法实现过程，提供给读者。
    </p>
    <img src="../../assets/images/newhelp/help21.png" alt="" />
    <img src="../../assets/images/newhelp/help22.png" alt="" />
    <p>
      同时生成知识图谱，对同一知识点进行多维度、多层次关联，帮助您快速发现相关文献，多角度获取把握相关知识。
    </p>
    <img src="../../assets/images/newhelp/help23.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
  .red {
    color: #fa0000;
  }
}
</style>
